// extracted by mini-css-extract-plugin
export default {"weightedDistributionContainer":"src-feature-config-users-team-__weighted-distribution-form_weightedDistributionContainer"};